<template>
  <div class="name-container">
    <label for="first-name-input" class="first-name-label">
      <!-- Update your first name (optional) -->
       {{ isDemo? 'Enter your first name' : 'Update your first name (optional)' }}
    </label>
    <input
      id="first-name-input"
      :value="value"
      @input="$emit('input', $event.target.value)"
      type="text"
      placeholder="Enter your first name"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
    >
    <span :class="[{ invalid: value.length > characterLimit }, 'first-name-character-limit']">
      {{ value.length }} / {{ characterLimit }} characters
    </span>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'FirstNameInput',
  props: {
    value: String,
    isDemo: {
      type: Boolean,
      required: false,
      default: false
    },
    characterLimit: Number
  },
  methods: {
    emitChange: function(event) {
      console.log(this.value);
      console.log(event.target.checked);
      this.$emit('change', event.target.checked);
    }
  }
})
</script>

<style scoped lang="scss">
.name-container {
    flex: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1em 0.6em;
  margin: 0 auto;
  width: 80%;
  min-height: max-content;
}

.first-name-label {
  font-size: 0.9em;
  padding: 0.4em 0.8em;
}

#first-name-input {
  font-size: 1em;
  width: 16em;
  padding: 0.4em 0.8em;
  font-family: inherit;
}

.first-name-character-limit {
  font-size: 0.8em;
  padding: 0.4em 0.8em;
  &.invalid {
    color: $crimson;
  }
}


</style>